import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Graphics } from '@inlet/react-pixi';
import { useCallback, useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { Sentry, SentryTeam } from 'app/utils/sentry';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextBreak } from 'flow-builder/node/textBreak';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import WidgetCustomizationModal from '../../../containers/modals/widgetcustomization';
const translatePayload = (node) => {
    const { nextNodeId } = node.payload;
    return [
        {
            id: uuid(),
            label: 'arrow',
            connection: nextNodeId,
        },
    ];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign(Object.assign({}, node.payload), { nextNodeId: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
export const WidgetCustomizationNodeAttributes = {
    iconName: 'widget-customize',
    label: 'Customization',
    color: hexStringToNumber(flowNodeColor.blue),
    translatePayload,
    updateConnection,
    NodeContent: WidgetCustomizationNode,
    ActionModal: WidgetCustomizationModal,
};
export function WidgetCustomizationNode({ node, }) {
    const { payload } = node;
    const { theme, medium, small } = payload;
    const mobilePosition = small === null || small === void 0 ? void 0 : small.minimized_view.position.replace('_', ' ');
    const desktopPosition = medium === null || medium === void 0 ? void 0 : medium.minimized_view.position.replace('_', ' ');
    if (!small || !medium)
        Sentry.captureMessage('Invalid Widgetcustomization', {
            contexts: {
                node: Object.assign(Object.assign({}, node), { payload: JSON.stringify(payload) }),
            },
            tags: { team: SentryTeam.Routing },
        });
    const drawThemePill = useCallback((graphics) => {
        graphics.clear();
        graphics.beginFill(hexStringToNumber(theme.color));
        graphics.drawRoundedRect(85, 6, 30, 12, 6);
        graphics.endFill();
    }, [theme]);
    return (_jsx(TextContent, { children: useMemo(() => (_jsxs(_Fragment, { children: [_jsx(TextEllipsis, { children: _jsx(Text, { weight: "normal", text: "Theme color:" }) }), _jsx(Graphics, { draw: drawThemePill }), _jsxs(TextBreak, Object.assign({ offset: { x: 0, y: 5 } }, { children: [_jsx(Text, { weight: "normal", text: "Position:" }), _jsx(Text, { weight: "semibold", text: `${mobilePosition} on mobile and ${desktopPosition} on desktop` })] }))] })), [drawThemePill, mobilePosition, desktopPosition]) }));
}
